export const REDIRECT_TO_ROUTE = 'navigation@redirect-to-route';

export const SET_REDIRECT = 'navigation@set-redirect';